import DOMPurify from "dompurify";

export const sanitizeInput = (input:string) => {
    // First remove obvious HTML tags
    const noTags = input.replace(/<[^>]*>/g, '');
    // Then sanitize thoroughly
    return DOMPurify.sanitize(noTags, { ALLOWED_TAGS: [] });
  };